/** Single source of truth for brand and contact details. */
export const site = {
  brand: "Davis's Reel Thoughts",
  /** His name. The brand is the site; this is the person who writes it. */
  author: "Davis Lee",
  tagline: "Talking movies like normal people",
  domain: "davis-reel-thoughts.com",

  /** Earliest entry in the watch diary, so the hero does not have to guess. */
  watchingSince: 2024,

  /**
   * Minimum age for an account. Set by COPPA, not by preference — under 13 is
   * the line at which collecting an email address needs verifiable parental
   * consent, which this site has no way to obtain.
   *
   * Lives here because it is stated in two places that must not drift: the
   * sign-up form and the Terms.
   */
  minAge: 13,

  contact: {
    email: "davisisawesome10@gmail.com",
    phone: "(213) 929-9006",
    /** E.164 for the tel: link. */
    phoneHref: "+12139299006",
    instagram: "@davis.young.lee",
    instagramUrl: "https://instagram.com/davis.young.lee",
    letterboxd: "Davislee",
    letterboxdUrl: "https://letterboxd.com/Davislee",
  },
} as const;
